import { Injector } from "@angular/core";
import { SimpleSearchListNode } from "../../SimpleSearchListNode"
import { EntityEnum } from "../../EntityEnum";
import { DevelopmentSubstanceAutoUploadEntity } from "../Entity/DevelopmentSubstanceAutoUploadEntity";
import { DevelopmentSubtanceEntityListView } from "../../../Data/MedicinalProductData/DevelopmentSubstanceEntityListView";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { BaseNode } from "../../BaseNode";



export class TreeNodeMedicinalProductsDevelopmentSubstance extends SimpleSearchListNode {

    useHist: boolean = false;
    constructor(injector: Injector, items: any[]|undefined, useHist: boolean) {
        super(injector, new DevelopmentSubtanceEntityListView(items), "Development Substances", useHist ? EntityEnum.developmentSubstanceHist :  EntityEnum.developmentSubstance);
        this.useHist = useHist;
    }

    override addChild(model: any): BaseNode|undefined {
        const labelTemplate = `${model.stamp_nullif != null?'Nullified - ':model.replaced_stamp?'':'Current '}Development - ${model.ev_Code} - ${model.substancename} ${this.ioc?.get(LookupGetService).retrieveValueFromCache("substancenameorcode",model.iscode)}`;
        return this.addChildNode(DevelopmentSubstanceAutoUploadEntity,labelTemplate, this,model,this.useHist, false,false);
    }

    override getCriteriaFields(): string[] {
        return ['ev_Code','substancename'];
    }

    override getPlaceHolderTemplate(): string {
        return "Search for substance records owned in the XEVMPD by your HQ";
    }

    override getPlaceHolderToolTipTemplate(): string {
        return "The search result will display the preferred name of the substance and the assigned EV Code"
    }
}